export default __webpack_public_path__ + "static/media/black_pawn.c3eb0901.png";